/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import { css } from 'styled-components';

const TaskStyles = css`
  .task {
    &--loading {
      position: relative,
      width: 100vw,
      height: 100vh,
      background-color: #e4e9f1,
    }
  }
`;

export default TaskStyles;
